const initialState = { currentLanguage: "English", languageContent: [], languageContentNew: [] }

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case "CURRENT_LANGUAGE":
            return { ...state, currentLanguage: payload };
        case "LANGUAGE_CONTENT":
            return { ...state, languageContent: payload };
        case "LANGUAGE_CONTENT_NEW":
            return { ...state, languageContentNew: payload };
        default:
            return state;
    }
}
